import {
    Badge,
    Button,
    Card,
    Dialog,
    Heading,
    Pane,
    Tab,
    Table,
    Tablist, Text,
    Textarea
} from 'evergreen-ui';
import { Component } from 'react';
import { connect } from 'react-redux';

import {
    approveChangeRequest,
    employeeApproveChange,
    employeeRejectChange,
    getChangeRequests,
    getShops,
    overrideChangeRequest,
    rejectChangeRequest
} from '../actions/ScheduleActions';

const STATUS_COLORS = {
    pending_employee: 'yellow',
    pending_admin: 'orange',
    approved: 'green',
    rejected: 'red',
    cancelled: 'neutral'
};

const STATUS_LABELS = {
    pending_employee: 'Așteaptă angajat',
    pending_admin: 'Așteaptă admin',
    approved: 'Aprobat',
    rejected: 'Respins',
    cancelled: 'Anulat'
};

const TYPE_LABELS = {
    swap: 'Schimb',
    modify: 'Modificare',
    cancel: 'Anulare',
    add: 'Adăugare'
};

class ScheduleChangeRequests extends Component {
    state = {
        selectedTab: 'pending',
        showProcessDialog: false,
        showDetailsDialog: false,
        showOverrideDialog: false,
        selectedRequest: null,
        overrideRequest: null, // Separate state for override dialog
        processAction: null,
        adminNotes: '',
        overrideNotes: '' // Separate notes for override
    };

    componentDidMount() {
        this.loadRequests();
        this.props.dispatch(getShops());
    }

    loadRequests = () => {
        const { selectedTab } = this.state;
        this.props.dispatch(getChangeRequests({
            pendingOnly: selectedTab === 'pending'
        }));
    }

    handleApprove = async () => {
        const { selectedRequest, adminNotes } = this.state;
        await this.props.dispatch(approveChangeRequest(selectedRequest.id, adminNotes));
        this.handleCloseProcessDialog();
        this.loadRequests();
    }

    handleReject = async () => {
        const { selectedRequest, adminNotes } = this.state;
        await this.props.dispatch(rejectChangeRequest(selectedRequest.id, adminNotes));
        this.handleCloseProcessDialog();
        this.loadRequests();
    }

    handleOverride = async () => {
        const { overrideRequest, overrideNotes } = this.state;
        console.log('handleOverride called, overrideRequest:', overrideRequest?.id, 'showOverrideDialog:', this.state.showOverrideDialog);

        if (!overrideRequest) {
            console.log('No overrideRequest, aborting');
            return;
        }

        if (!this.state.showOverrideDialog) {
            console.log('Dialog not shown, aborting');
            return;
        }

        try {
            console.log('Dispatching override for request:', overrideRequest.id);
            await this.props.dispatch(overrideChangeRequest(overrideRequest.id, overrideNotes));
            this.setState({
                showOverrideDialog: false,
                overrideRequest: null,
                overrideNotes: ''
            });
            this.loadRequests();
        } catch (err) {
            console.error('Override failed:', err);
        }
    }

    handleOpenOverrideDialog = (request) => {
        console.log('Opening override dialog for request:', request.id);
        this.setState({
            showOverrideDialog: true,
            showDetailsDialog: false,
            overrideRequest: request,
            overrideNotes: ''
        });
    }

    handleCloseOverrideDialog = () => {
        console.log('Closing override dialog');
        this.setState({
            showOverrideDialog: false,
            overrideRequest: null,
            overrideNotes: ''
        });
    }

    handleOpenProcessDialog = (request, action) => {
        this.setState({
            showProcessDialog: true,
            showDetailsDialog: false,
            selectedRequest: request,
            processAction: action,
            adminNotes: ''
        });
    }

    handleCloseProcessDialog = () => {
        this.setState({
            showProcessDialog: false,
            selectedRequest: null,
            processAction: null,
            adminNotes: ''
        });
    }

    handleOpenDetailsDialog = (request) => {
        this.setState({
            showDetailsDialog: true,
            selectedRequest: request
        });
    }

    handleCloseDetailsDialog = () => {
        // Only clear selectedRequest if process dialog is not being opened
        if (!this.state.showProcessDialog) {
            this.setState({
                showDetailsDialog: false,
                selectedRequest: null
            });
        } else {
            this.setState({
                showDetailsDialog: false
            });
        }
    }

    handleTabChange = (tab) => {
        this.setState({ selectedTab: tab }, this.loadRequests);
    }

    isManagerOrAdmin = () => {
        const { user } = this.props;
        return user && user.role && user.role.level >= 2 && user.role.name !== 'Staff';
    }

    renderSwapInfo = (request) => {
        if (request.type !== 'swap') {
            return null;
        }

        const original = request.originalSchedule;
        const swapWith = request.swapWithSchedule;

        return (
            <Pane marginTop={8} padding={8} background="tint1" borderRadius={4}>
                <Text size={300} fontWeight={500}>Schimb de ture:</Text>
                <Pane marginTop={4}>
                    <Text size={300} display="block">
                        <strong>{original?.employee?.user?.name}</strong> ({original?.date} {original?.startTime}-{original?.endTime})
                    </Text>
                    <Text size={300} display="block" marginY={4}>↕️ se schimbă cu</Text>
                    <Text size={300} display="block">
                        <strong>{swapWith?.employee?.user?.name || request.swapWithEmployee?.user?.name}</strong> ({swapWith?.date} {swapWith?.startTime}-{swapWith?.endTime})
                    </Text>
                </Pane>
            </Pane>
        );
    }

    canEmployeeApprove = (request) => {
        const { user } = this.props;
        // Check if the current user is the employee being asked to swap
        return request.status === 'pending_employee' && 
               request.swapWithEmployee?.user?.id === user?.id;
    }

    handleEmployeeApprove = async (request) => {
        console.log('handleEmployeeApprove called with request:', request);
        try {
            console.log('Calling employeeApproveChange with ID:', request.id);
            const result = await this.props.dispatch(employeeApproveChange(request.id));
            console.log('Employee approve result:', result);
            this.loadRequests();
        } catch (err) {
            console.error('Error in handleEmployeeApprove:', err);
        }
    }

    handleEmployeeReject = async (request) => {
        console.log('handleEmployeeReject called with request:', request);
        try {
            console.log('Calling employeeRejectChange with ID:', request.id);
            const result = await this.props.dispatch(employeeRejectChange(request.id));
            console.log('Employee reject result:', result);
            this.loadRequests();
        } catch (err) {
            console.error('Error in handleEmployeeReject:', err);
        }
    }

    getFilteredRequests = () => {
        const { changeRequests } = this.props;
        const { selectedTab } = this.state;

        if (selectedTab === 'pending') {
            return changeRequests.filter(r =>
                r.status === 'pending_admin' || r.status === 'pending_employee'
            );
        } else if (selectedTab === 'processed') {
            return changeRequests.filter(r =>
                r.status === 'approved' || r.status === 'rejected' || r.status === 'cancelled'
            );
        }
        return changeRequests;
    }

    render() {
        const { selectedTab, showProcessDialog, selectedRequest, processAction, adminNotes } = this.state;
        const filteredRequests = this.getFilteredRequests();
        const canProcess = this.isManagerOrAdmin();

        return (
            <Pane padding={16}>
                <Pane display="flex" justifyContent="space-between" alignItems="center" marginBottom={16}>
                    <Heading size={600}>Cereri Modificare Program</Heading>
                </Pane>

                {/* Tabs */}
                <Tablist marginBottom={16}>
                    <Tab
                        isSelected={selectedTab === 'pending'}
                        onSelect={() => this.handleTabChange('pending')}
                    >
                        În așteptare
                    </Tab>
                    <Tab
                        isSelected={selectedTab === 'processed'}
                        onSelect={() => this.handleTabChange('processed')}
                    >
                        Procesate
                    </Tab>
                    <Tab
                        isSelected={selectedTab === 'all'}
                        onSelect={() => this.handleTabChange('all')}
                    >
                        Toate
                    </Tab>
                </Tablist>

                {/* Requests Table */}
                <Table>
                    <Table.Head>
                        <Table.TextHeaderCell>Data cererii</Table.TextHeaderCell>
                        <Table.TextHeaderCell>Tip</Table.TextHeaderCell>
                        <Table.TextHeaderCell>Solicitat de</Table.TextHeaderCell>
                        <Table.TextHeaderCell>Angajat afectat</Table.TextHeaderCell>
                        <Table.TextHeaderCell>Tură originală</Table.TextHeaderCell>
                        <Table.TextHeaderCell>Motiv</Table.TextHeaderCell>
                        <Table.TextHeaderCell>Status</Table.TextHeaderCell>
                        <Table.TextHeaderCell>Acțiuni</Table.TextHeaderCell>
                    </Table.Head>
                    <Table.Body>
                        {filteredRequests.length === 0 ? (
                            <Table.Row>
                                <Table.TextCell colSpan={8}>
                                    <Pane textAlign="center" padding={32}>
                                        Nu există cereri {selectedTab === 'pending' ? 'în așteptare' : ''}
                                    </Pane>
                                </Table.TextCell>
                            </Table.Row>
                        ) : (
                            filteredRequests.map(request => (
                                <Table.Row
                                    key={request.id}
                                    isSelectable
                                    onSelect={() => this.handleOpenDetailsDialog(request)}
                                >
                                    <Table.TextCell>
                                        {request.createdAt?.format('DD.MM.YYYY HH:mm')}
                                    </Table.TextCell>
                                    <Table.TextCell>
                                        <Badge color="blue">
                                            {TYPE_LABELS[request.type] || request.type}
                                        </Badge>
                                    </Table.TextCell>
                                    <Table.TextCell>
                                        {request.requestedBy?.user?.name || '-'}
                                    </Table.TextCell>
                                    <Table.TextCell>
                                        {request.type === 'swap'
                                            ? request.swapWithEmployee?.user?.name
                                            : request.originalSchedule?.employee?.user?.name || '-'}
                                    </Table.TextCell>
                                    <Table.TextCell>
                                        {request.originalSchedule ? (
                                            <Text size={300}>
                                                {request.originalSchedule.date} {request.originalSchedule.startTime}-{request.originalSchedule.endTime}
                                            </Text>
                                        ) : '-'}
                                    </Table.TextCell>
                                    <Table.TextCell>
                                        <Text size={300}>{request.reason ? (request.reason.length > 30 ? request.reason.substring(0, 30) + '...' : request.reason) : '-'}</Text>
                                    </Table.TextCell>
                                    <Table.TextCell>
                                        <Badge color={STATUS_COLORS[request.status]}>
                                            {STATUS_LABELS[request.status] || request.status}
                                        </Badge>
                                    </Table.TextCell>
                                    <Table.TextCell>
                                        {request.status === 'pending_admin' && canProcess && (
                                            <Pane display="flex" gap={8}>
                                                <Button
                                                    size="small"
                                                    intent="success"
                                                    onClick={(e) => { e.stopPropagation(); this.handleOpenProcessDialog(request, 'approve'); }}
                                                >
                                                    Aprobă
                                                </Button>
                                                <Button
                                                    size="small"
                                                    intent="danger"
                                                    onClick={(e) => { e.stopPropagation(); this.handleOpenProcessDialog(request, 'reject'); }}
                                                >
                                                    Respinge
                                                </Button>
                                            </Pane>
                                        )}
                                        {request.status === 'pending_employee' && canProcess && (
                                            <Pane display="flex" gap={8}>
                                                <Button
                                                    size="small"
                                                    intent="warning"
                                                    onClick={(e) => { e.stopPropagation(); this.handleOpenOverrideDialog(request); }}
                                                >
                                                    Override
                                                </Button>
                                                <Button
                                                    size="small"
                                                    intent="danger"
                                                    onClick={(e) => { e.stopPropagation(); this.handleOpenProcessDialog(request, 'reject'); }}
                                                >
                                                    Respinge
                                                </Button>
                                            </Pane>
                                        )}
                                        {request.status === 'pending_employee' && this.canEmployeeApprove(request) && (
                                            <Pane display="flex" gap={8}>
                                                <Button
                                                    size="small"
                                                    intent="success"
                                                    onClick={(e) => { 
                                                        e.stopPropagation(); 
                                                        e.preventDefault(); 
                                                        this.handleEmployeeApprove(request); 
                                                    }}
                                                >
                                                    Accept
                                                </Button>
                                                <Button
                                                    size="small"
                                                    intent="danger"
                                                    onClick={(e) => { 
                                                        e.stopPropagation(); 
                                                        e.preventDefault(); 
                                                        this.handleEmployeeReject(request); 
                                                    }}
                                                >
                                                    Refuz
                                                </Button>
                                            </Pane>
                                        )}
                                        {request.status === 'pending_employee' && !canProcess && !this.canEmployeeApprove(request) && (
                                            <Text size={300} color="muted">
                                                Așteaptă coleg
                                            </Text>
                                        )}
                                        {(request.status === 'approved' || request.status === 'rejected') && (
                                            <Text size={300} color="muted">
                                                {request.processedBy?.name && `de ${request.processedBy.name}`}
                                            </Text>
                                        )}
                                    </Table.TextCell>
                                </Table.Row>
                            ))
                        )}
                    </Table.Body>
                </Table>

                {/* Process Dialog */}
                <Dialog
                    isShown={showProcessDialog}
                    title={processAction === 'approve' ? 'Aprobă cererea' : 'Respinge cererea'}
                    onCloseComplete={this.handleCloseProcessDialog}
                    confirmLabel={processAction === 'approve' ? 'Aprobă' : 'Respinge'}
                    intent={processAction === 'approve' ? 'success' : 'danger'}
                    onConfirm={processAction === 'approve' ? this.handleApprove : this.handleReject}
                >
                    {selectedRequest && (
                        <Pane>
                            <Card
                                background="tint1"
                                padding={16}
                                marginBottom={16}
                                borderRadius={4}
                            >
                                <Pane display="flex" justifyContent="space-between" marginBottom={8}>
                                    <Text fontWeight={500}>Tip cerere:</Text>
                                    <Badge color="blue">Schimb de ture</Badge>
                                </Pane>
                                <Pane display="flex" justifyContent="space-between" marginBottom={8}>
                                    <Text fontWeight={500}>Solicitat de:</Text>
                                    <Text>{selectedRequest.requestedBy?.user?.name || '-'}</Text>
                                </Pane>
                                {this.renderSwapInfo(selectedRequest)}
                                <Pane marginTop={8}>
                                    <Text fontWeight={500}>Motiv:</Text>
                                    <Text display="block" marginTop={4}>
                                        {selectedRequest.reason || 'Nu a fost specificat'}
                                    </Text>
                                </Pane>
                            </Card>

                            <Pane>
                                <label>Note admin (opțional)</label>
                                <Textarea
                                    value={adminNotes}
                                    onChange={(e) => this.setState({ adminNotes: e.target.value })}
                                    placeholder="Adăugați note sau comentarii..."
                                />
                            </Pane>
                        </Pane>
                    )}
                </Dialog>

                {/* Details Dialog */}
                <Dialog
                    isShown={this.state.showDetailsDialog}
                    title="Detalii Cerere Modificare"
                    onCloseComplete={this.handleCloseDetailsDialog}
                    hasFooter={this.state.selectedRequest?.status === 'pending_admin' && canProcess}
                    confirmLabel="Aprobă"
                    intent="success"
                    onConfirm={() => this.handleOpenProcessDialog(this.state.selectedRequest, 'approve')}
                    cancelLabel={this.state.selectedRequest?.status === 'pending_admin' && canProcess ? "Respinge" : "Închide"}
                    onCancel={() => {
                        if (this.state.selectedRequest?.status === 'pending_admin' && canProcess) {
                            this.handleOpenProcessDialog(this.state.selectedRequest, 'reject');
                        } else {
                            this.handleCloseDetailsDialog();
                        }
                    }}
                    width={600}
                >
                    {this.state.selectedRequest && (
                        <Pane>
                            {/* Status Badge */}
                            <Pane display="flex" justifyContent="center" marginBottom={16}>
                                <Badge color={STATUS_COLORS[this.state.selectedRequest.status]} size={500}>
                                    {STATUS_LABELS[this.state.selectedRequest.status] || this.state.selectedRequest.status}
                                </Badge>
                            </Pane>

                            {/* Request Info Card */}
                            <Card background="tint1" padding={16} marginBottom={16} borderRadius={4}>
                                <Heading size={400} marginBottom={12}>Informații Cerere</Heading>

                                <Pane display="flex" justifyContent="space-between" marginBottom={8}>
                                    <Text fontWeight={500}>ID Cerere:</Text>
                                    <Text>#{this.state.selectedRequest.id}</Text>
                                </Pane>
                                <Pane display="flex" justifyContent="space-between" marginBottom={8}>
                                    <Text fontWeight={500}>Tip:</Text>
                                    <Badge color="blue">
                                        {TYPE_LABELS[this.state.selectedRequest.type] || this.state.selectedRequest.type}
                                    </Badge>
                                </Pane>
                                <Pane display="flex" justifyContent="space-between" marginBottom={8}>
                                    <Text fontWeight={500}>Data cererii:</Text>
                                    <Text>{this.state.selectedRequest.createdAt?.format('DD.MM.YYYY HH:mm')}</Text>
                                </Pane>
                                <Pane display="flex" justifyContent="space-between" marginBottom={8}>
                                    <Text fontWeight={500}>Solicitat de:</Text>
                                    <Text>{this.state.selectedRequest.requestedBy?.user?.name || '-'}</Text>
                                </Pane>
                            </Card>

                            {/* Original Schedule Card */}
                            <Card background="tint1" padding={16} marginBottom={16} borderRadius={4}>
                                <Heading size={400} marginBottom={12}>Tură Originală</Heading>

                                {this.state.selectedRequest.originalSchedule ? (
                                    <>
                                        <Pane display="flex" justifyContent="space-between" marginBottom={8}>
                                            <Text fontWeight={500}>Angajat:</Text>
                                            <Text>{this.state.selectedRequest.originalSchedule.employee?.user?.name || '-'}</Text>
                                        </Pane>
                                        <Pane display="flex" justifyContent="space-between" marginBottom={8}>
                                            <Text fontWeight={500}>Data:</Text>
                                            <Text>{this.state.selectedRequest.originalSchedule.date}</Text>
                                        </Pane>
                                        <Pane display="flex" justifyContent="space-between" marginBottom={8}>
                                            <Text fontWeight={500}>Ora:</Text>
                                            <Text>{this.state.selectedRequest.originalSchedule.startTime} - {this.state.selectedRequest.originalSchedule.endTime}</Text>
                                        </Pane>
                                        {this.state.selectedRequest.originalSchedule.notes && (
                                            <Pane marginTop={8}>
                                                <Text fontWeight={500}>Note:</Text>
                                                <Text display="block" marginTop={4}>{this.state.selectedRequest.originalSchedule.notes}</Text>
                                            </Pane>
                                        )}
                                    </>
                                ) : (
                                    <Text color="muted">Nu există informații despre tura originală</Text>
                                )}
                            </Card>

                            {/* Swap Info Card */}
                            {this.state.selectedRequest.type === 'swap' && (
                                <Card background="blueTint" padding={16} marginBottom={16} borderRadius={4}>
                                    <Heading size={400} marginBottom={12}>Informații Schimb</Heading>

                                    <Pane display="flex" justifyContent="space-between" marginBottom={8}>
                                        <Text fontWeight={500}>Schimb cu angajatul:</Text>
                                        <Text>{this.state.selectedRequest.swapWithEmployee?.user?.name || '-'}</Text>
                                    </Pane>
                                    {this.state.selectedRequest.swapWithSchedule && (
                                        <Pane display="flex" justifyContent="space-between" marginBottom={8}>
                                            <Text fontWeight={500}>Tura lor:</Text>
                                            <Text>
                                                {this.state.selectedRequest.swapWithSchedule.date} {this.state.selectedRequest.swapWithSchedule.startTime}-{this.state.selectedRequest.swapWithSchedule.endTime}
                                            </Text>
                                        </Pane>
                                    )}

                                    {/* Workflow Status */}
                                    <Pane marginTop={12} paddingTop={12} borderTop="muted">
                                        <Text fontWeight={600} display="block" marginBottom={8}>Flux Aprobare:</Text>
                                        <Pane display="flex" alignItems="center" gap={8} marginBottom={8}>
                                            <Badge color={this.state.selectedRequest.status !== 'pending_employee' ? 'green' : 'yellow'}>
                                                1. Angajat
                                            </Badge>
                                            <Text>→</Text>
                                            <Badge color={
                                                this.state.selectedRequest.status === 'approved' ? 'green' :
                                                this.state.selectedRequest.status === 'rejected' ? 'red' :
                                                this.state.selectedRequest.status === 'pending_admin' ? 'yellow' : 'neutral'
                                            }>
                                                2. Admin
                                            </Badge>
                                        </Pane>

                                        {this.state.selectedRequest.employeeApproved === true && (
                                            <Text size={300} color="green" display="block">
                                                ✓ Aprobat de {this.state.selectedRequest.swapWithEmployee?.user?.name} la {this.state.selectedRequest.employeeApprovedAt?.format?.('DD.MM.YYYY HH:mm')}
                                            </Text>
                                        )}
                                        {this.state.selectedRequest.employeeApproved === false && (
                                            <Text size={300} color="red" display="block">
                                                ✗ Respins de angajat
                                            </Text>
                                        )}
                                        {this.state.selectedRequest.status === 'pending_employee' && (
                                            <Text size={300} color="muted" display="block">
                                                ⏳ Așteaptă aprobarea lui {this.state.selectedRequest.swapWithEmployee?.user?.name}
                                            </Text>
                                        )}
                                    </Pane>
                                </Card>
                            )}

                            {/* Reason Card */}
                            <Card background="tint1" padding={16} marginBottom={16} borderRadius={4}>
                                <Heading size={400} marginBottom={12}>Motiv</Heading>
                                <Text>{this.state.selectedRequest.reason || 'Nu a fost specificat un motiv'}</Text>
                            </Card>

                            {/* Processing Info Card - if processed */}
                            {(this.state.selectedRequest.status === 'approved' || this.state.selectedRequest.status === 'rejected') && (
                                <Card
                                    background={this.state.selectedRequest.status === 'approved' ? 'greenTint' : 'redTint'}
                                    padding={16}
                                    borderRadius={4}
                                >
                                    <Heading size={400} marginBottom={12}>
                                        {this.state.selectedRequest.status === 'approved' ? 'Aprobat' : 'Respins'}
                                    </Heading>

                                    <Pane display="flex" justifyContent="space-between" marginBottom={8}>
                                        <Text fontWeight={500}>Procesat de:</Text>
                                        <Text>{this.state.selectedRequest.processedBy?.name || '-'}</Text>
                                    </Pane>
                                    <Pane display="flex" justifyContent="space-between" marginBottom={8}>
                                        <Text fontWeight={500}>Data procesării:</Text>
                                        <Text>{this.state.selectedRequest.processedAt?.format('DD.MM.YYYY HH:mm')}</Text>
                                    </Pane>
                                    {this.state.selectedRequest.adminNotes && (
                                        <Pane marginTop={8}>
                                            <Text fontWeight={500}>Note admin:</Text>
                                            <Text display="block" marginTop={4}>{this.state.selectedRequest.adminNotes}</Text>
                                        </Pane>
                                    )}
                                </Card>
                            )}
                        </Pane>
                    )}
                </Dialog>

                {/* Override Confirmation Dialog */}
                <Dialog
                    isShown={this.state.showOverrideDialog}
                    title="⚠️ Override Admin - Confirmare"
                    intent="warning"
                    onCloseComplete={this.handleCloseOverrideDialog}
                    confirmLabel="Confirm Override"
                    onConfirm={this.handleOverride}
                    cancelLabel="Anulează"
                >
                    {this.state.overrideRequest && (
                        <Pane>
                            <Pane background="yellowTint" padding={16} borderRadius={4} marginBottom={16}>
                                <Text fontWeight={500} color="warning">
                                    ⚠️ Atenție: Această acțiune va aproba schimbul FĂRĂ aprobarea angajatului afectat.
                                </Text>
                                <Text display="block" marginTop={8}>
                                    {this.state.overrideRequest.swapWithEmployee?.user?.name} nu a aprobat încă acest schimb.
                                    Prin override, tu îți asumi responsabilitatea pentru această decizie.
                                </Text>
                            </Pane>

                            <Card background="tint1" padding={16} marginBottom={16} borderRadius={4}>
                                <Heading size={400} marginBottom={8}>Schimb propus:</Heading>
                                {this.renderSwapInfo(this.state.overrideRequest)}
                            </Card>

                            <Pane>
                                <label>Motiv override (recomandat)</label>
                                <Textarea
                                    value={this.state.overrideNotes}
                                    onChange={(e) => this.setState({ overrideNotes: e.target.value })}
                                    placeholder="Explică de ce aprobi fără acordul angajatului..."
                                />
                            </Pane>
                        </Pane>
                    )}
                </Dialog>
            </Pane>
        );
    }
}

function mapStateToProps(state) {
    return {
        changeRequests: state.scheduleProgram.changeRequests || [],
        shops: state.scheduleProgram.shops,
        user: state.authentication.user
    };
}

export default connect(mapStateToProps)(ScheduleChangeRequests);
